module.exports = __webpack_public_path__ + "static/media/multiple-stops.cf66a7eb.svg";